/* =========================================================================
 * Featured collection (Rapi tiers) — client behavior
 * -------------------------------------------------------------------------
 * - Mini pack-size chips (radio group with arrow-key navigation)
 * - Chip selection sets the native product form's quantity input and
 *   swaps in the chip's pre-rendered pack total / struck total / price per can
 *   (snippets/tso-money markup)
 * - Add to Cart is the theme's own product-form element; the actual
 *   discount is applied in the cart by the Rapi Bundle discount function
 *
 * No price maths here: snippets/tso-pack-price renders every string.
 * ========================================================================= */
(function () {
  'use strict';

  if (window.__TSO_MINI_INIT__) return;
  window.__TSO_MINI_INIT__ = true;

  /* -------------------------------------------------------------- pricing */
  /* The prices are rendered by Liquid (snippets/tso-pack-price — the same rule the
     product page and the cart use) and carried on each chip as ready strings, so
     nothing is calculated or rounded here: the chip's strings are swapped in. */
  function applyTier(card, chip) {
    var qty = parseInt(chip.getAttribute('data-qty'), 10) || 1;
    /* Markup rendered by Liquid (snippets/tso-money) from the theme's own prices */
    var total = chip.getAttribute('data-total-html') || '';
    var was = chip.getAttribute('data-was-total-html') || '';
    var per = chip.getAttribute('data-per-html') || '';

    var priceEl = card.querySelector('[data-tso-price]');
    var wasEl = card.querySelector('[data-tso-was]');
    var totalEl = card.querySelector('[data-tso-total]');
    var perEl = card.querySelector('[data-tso-per]');

    /* The Add button shows the pack total — what the cart will charge;
       the line under it the price per can in that pack */
    if (totalEl && total) totalEl.innerHTML = total;
    if (perEl && per) perEl.innerHTML = per;

    /* The sale badge (snippets/tso-sale-badge) shows the total discount of the chosen pack */
    var off = parseInt(chip.getAttribute('data-off-pct'), 10) || 0;
    var saveEl = card.querySelector('[data-tso-save]');
    if (saveEl && off > 0) saveEl.textContent = off + '%';
    if (wasEl) {
      wasEl.innerHTML = was;
      wasEl.hidden = !was;
    }
    if (priceEl) priceEl.classList.toggle('price--on-sale', !!was);

    var qtyInput = card.querySelector('[data-tso-qty]');
    if (qtyInput) qtyInput.value = String(qty);

    /* Vont bundles: the vape / can count badges follow the chosen pack (10 vapes x 10 combos = 100) */
    card.querySelectorAll('[data-tso-count]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-tso-count'), 10) || 0;
      var num = el.querySelector('[data-tso-count-num]');
      if (num) num.textContent = String(base * qty);
    });
  }

  function selectChip(card, chip) {
    var chips = card.querySelectorAll('[data-tso-chip]');
    chips.forEach(function (c) {
      var isMatch = c === chip;
      c.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      c.setAttribute('tabindex', isMatch ? '0' : '-1');
    });
    applyTier(card, chip);
  }

  /* ------------------------------------------------------------ listeners */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-tso-chip]');
    if (!chip || chip.disabled) return;
    var card = chip.closest('[data-tso-card]');
    if (!card) return;
    selectChip(card, chip);
  });

  /* Roving radio-group keyboard support */
  document.addEventListener('keydown', function (e) {
    var chip = e.target.closest && e.target.closest('[data-tso-chip]');
    if (!chip) return;

    var group = chip.closest('[data-tso-chips]');
    var card = chip.closest('[data-tso-card]');
    if (!group || !card) return;

    var chips = Array.prototype.slice.call(group.querySelectorAll('[data-tso-chip]:not([disabled])'));
    var idx = chips.indexOf(chip);
    if (idx === -1) return;

    var next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      next = chips[(idx + 1) % chips.length];
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      next = chips[(idx - 1 + chips.length) % chips.length];
    } else if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      selectChip(card, chip);
      return;
    }

    if (next) {
      e.preventDefault();
      selectChip(card, next);
      next.focus();
    }
  });
})();

/* TSO: se till att det förvalda pack-chipet (30) syns direkt på mobil —
   chipsraden scrollas så valt chip centreras när raden är overflowad. */
(function () {
  function centerSelectedChips(root) {
    (root || document).querySelectorAll('.tso-mini__chips').forEach(function (chips) {
      if (chips.scrollWidth <= chips.clientWidth + 4) return;
      var sel = chips.querySelector('[aria-checked="true"]');
      if (!sel) return;
      var cr = chips.getBoundingClientRect();
      var sr = sel.getBoundingClientRect();
      var target = (sr.left - cr.left + chips.scrollLeft) - (chips.clientWidth - sr.width) / 2;
      chips.scrollLeft = Math.max(0, target);
    });
  }
  var run = function () { centerSelectedChips(); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && ((n.matches && n.matches('.tso-mini__chips')) || (n.querySelector && n.querySelector('.tso-mini__chips')))) {
          run();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
